module.exports = __webpack_public_path__ + "img/PinHome.67f96f21.svg";